import React, { useEffect, useState } from "react";
import CardWithImage from "../../components/Cards/CardWithImage";
import axiosInstance from "../../services/api/axiosInstance.js";
import images from "../../utils/images.js";
import { BsFillArrowUpCircleFill } from "react-icons/bs";
import { useSelector } from "react-redux";
import { Modal, Spinner } from "react-bootstrap";

const CommunityPage = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const sso = queryParams.get("sso");
    const sig = queryParams.get("sig");

    const { chatBotState } = useSelector((state) => state);
    const [communityData, setCommunityData] = useState([])
    const [communityLoading, setCommunityLoading] = useState(false);
    const [modalApiContent, setModalApiContent] = useState([])
    const [modalLoading, setModalLoading] = useState(false)
    const [communityPosts, setCommunityPosts] = useState([])
    const [eventPosts, setEventPosts] = useState([])
    const [articlePosts, setArticlePosts] = useState([])
    const [communityTeam, setCommunityTeam] = useState([])
    const [showDiscourseModal, setShowDiscourseModal] = useState(false)
    const [discourseUrl, setDiscourseUrl] = useState(null)

    // Get Community Content
    useEffect(() => {
        setCommunityLoading(false);
        const getcommunityDatas = async () => {
            try {
                const response = await axiosInstance.get("/professional_community")
                if (response.data.error_code === 0) {
                    setCommunityLoading(true)
                    setCommunityData(response.data.data)
                    setCommunityPosts(response.data.data[0].community_posts)
                    setEventPosts(response.data.data[0].event_posts)
                    setArticlePosts(response.data.data[0].article_posts)
                    setCommunityTeam(response.data.data[0].community_team)
                }
            }

            catch (err) {
                console.log(err)
            }
        }
        (async () => getcommunityDatas())();

    }, [])

    // scroll to top 
    const [isVisible, setIsVisible] = useState(false);
    const handleScroll = () => {
        if (window.scrollY > 200) {
            setIsVisible(true);
        } else {
            setIsVisible(false);

        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    window.onscroll = function () {
        handleScroll();
    };

    // Post Community Modal Content
    const getModalData = async (modalId) => {
        let communityParams = {
            id: modalId
        }
        try {
            setModalLoading(true)
            const response = await axiosInstance.post("/get_detailed_description_community", communityParams)
            setModalLoading(false)
            if (response.data.error_code === 0) {
                setModalApiContent(response.data.data[0].detailed_description)
            }
        }
        catch (err) {
            console.log(err)
        }

    }

    useEffect(() => {
        if (sso && sig && chatBotState?.user_data?.email_id) {
            setShowDiscourseModal(true)
            getDiscourseUrl(sso, sig, chatBotState?.user_data?.email_id)

            var uri = window.location.toString();
            if (uri.indexOf("?") > 0) {
                var clean_uri = uri.substring(0, uri.indexOf("?"));
                window.history.replaceState({}, document.title, clean_uri);
            }
        }
    }, [sso, sig, chatBotState?.user_data?.email_id])

    async function getDiscourseUrl(sso, sig, email_id) {
        try {
            const { data } = await axiosInstance.get(`/discourse_sso?sso=${sso}&sig=${sig}&email_id=${email_id}`);

            if (data?.error_code === 0) setDiscourseUrl(data.data.redirect_url)
        } catch (Err) {
            console.log(Err)
        }
    }

    return (
        <>
            <div className={communityPosts.length > 6 || articlePosts.length > 6 || communityTeam.length > 6 ? "community-page-bg overflow-scroll" : "community-page-height community-page-bg overflow-scroll"}>
                <div className="container pt-5 bottom-navigation-margin" >
                    {/* <div className="w-100 py-5 text-center">
                        <button type="button" className="btn btn-brand-color" onClick={() => window.open("https://adradev.discourse.group/login", "_self")}>Join Community</button>
                    </div> */}

                    {/* Community and event of the month  */}
                    <section className=" row rounded-5 bg-light px-0 px-sm-5">
                        <div className="col-12 col-lg-6 mt-5 mt-lg-0">
                            <h3 className=" mb-4">
                                <span>Community</span>
                            </h3>
                            <p className="col-11 mb-3 mb-lg-5 ">Discover a community of peers with stories and ambitions that resonate with your own, offering support and inspiration as you transition into a fulfilling new chapter.
                            </p>
                            <div className="col-12 d-flex flex-wrap justify-content-center py-5 homepage-card-bg-color">
                                <div className="col-11 col-lg-9 p-0">
                                    {!communityLoading ?
                                        <div
                                            className="card border-0 d-inline-flex h-100 w-100 p-0 rounded-3 overflow-hidden placeholder-glow"
                                            aria-hidden="true"
                                        >
                                            <div className="col-12 p-3">
                                                <span className="placeholder col-12 py-4 rounded-top"></span>
                                                <span className="placeholder col-12 py-4"></span>
                                                <span className="placeholder col-12 py-4"></span>
                                                <span className="placeholder col-12 py-4 rounded-bottom"></span>
                                            </div>
                                            <div className="card-body p-0">
                                                <div className="p-3 py-4">
                                                    <h5 className="card-title ">
                                                        <span className="placeholder col-6 py-3 rounded-3"></span>
                                                    </h5>
                                                    <p className="card-text">
                                                        <span className="placeholder col-12 py-2 rounded "></span>
                                                        <span className="placeholder col-12 py-2 rounded"></span>
                                                        <span className="placeholder col-12 py-2 rounded"></span>
                                                        <span className="placeholder col-8 py-2 rounded"></span>
                                                    </p>
                                                </div>
                                                <div className="card-footer d-flex justify-content-between">
                                                    <button className="btn btn-outline-secondary placeholder col-5"></button>
                                                    <button className="btn btn-outline-secondary placeholder col-5"></button>
                                                </div>
                                            </div>
                                        </div>
                                        :

                                        (
                                            communityPosts && communityPosts.length > 0 ?
                                                communityPosts.map((value, index) => {
                                                    return (
                                                        <div className="col" key={index} style={{ height: '30rem' }}>
                                                            <>
                                                                <CardWithImage
                                                                    cardImage={value.image}
                                                                    cardTitle={value.title}
                                                                    id={value.id}
                                                                    cardTitleStyle="communityTitle"
                                                                    imageClassName="rounded-4 img-fluid community-img-height w-100"
                                                                    cardText={value.short_description}
                                                                    cardKey={index}
                                                                    carTextClassName="role-selection-description"
                                                                    cardParaTestId="professionalTestId"
                                                                    cardButtonTestId="cardButton"
                                                                    role="community"
                                                                    firstButton_Name="Join Community"
                                                                    secondButton_Name="Share"
                                                                    firstCardColor="brand-color"
                                                                    secondCardColor="outline-secondary"
                                                                    modalContent={modalApiContent}
                                                                    leftCommUrl={value.join_url}
                                                                    rightCommUrl={value.share_url}
                                                                    getModalData={getModalData}
                                                                    modalId={value.id}
                                                                    modalLoading={modalLoading}
                                                                />
                                                            </>


                                                            {/* scroll to top */}
                                                            <div
                                                                className="scroll-to-top-icon"
                                                                id="scroll-to-top-icon"
                                                                onClick={scrollToTop}
                                                                title="Scroll to top"
                                                                style={{ display: isVisible ? 'block' : 'none' }} // Show/hide button based on visibility state
                                                            >
                                                                <BsFillArrowUpCircleFill className='fs-1 brand-color' />
                                                            </div>

                                                        </div>
                                                    )
                                                })
                                                :
                                                <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                                                    <div className='d-flex  justify-content-center h-100'>
                                                        <img src={images.noRecordsFound} width={250} height={250} />
                                                    </div>
                                                </div>
                                        )


                                    }
                                </div>
                            </div>
                        </div>

                        <div className="col-12 col-lg-6 mt-5 mt-lg-0">
                            <h3 className="mb-4">
                                <span>Event of the month</span>
                            </h3>
                            <p className="col-11 mb-3 mb-lg-5 ">Join us to connect with others, discuss topics of interest, share stories, inspire each other, and stay informed. Don't miss this opportunity to engage and grow together</p>
                            <div className="col-12 d-flex flex-wrap justify-content-center py-5 homepage-card-bg-color">
                                <div className="col-11 col-lg-9 p-0">
                                    {!communityLoading ?
                                        <div
                                            className="card border-0 d-inline-flex h-100 w-100 p-0 rounded-3 overflow-hidden placeholder-glow"
                                            aria-hidden="true"
                                        >
                                            <div className="col-12 p-3">
                                                <span className="placeholder col-12 py-4 rounded-top"></span>
                                                <span className="placeholder col-12 py-4"></span>
                                                <span className="placeholder col-12 py-4"></span>
                                                <span className="placeholder col-12 py-4 rounded-bottom"></span>
                                            </div>
                                            <div className="card-body p-0">
                                                <div className="p-3 py-4">
                                                    <h5 className="card-title ">
                                                        <span className="placeholder col-6 py-3 rounded-3"></span>
                                                    </h5>
                                                    <p className="card-text">
                                                        <span className="placeholder col-12 py-2 rounded "></span>
                                                        <span className="placeholder col-12 py-2 rounded"></span>
                                                        <span className="placeholder col-12 py-2 rounded"></span>
                                                        <span className="placeholder col-8 py-2 rounded"></span>
                                                    </p>
                                                </div>
                                                <div className="card-footer d-flex justify-content-between">
                                                    <button className="btn btn-outline-secondary placeholder col-5"></button>
                                                    <button className="btn btn-outline-secondary placeholder col-5"></button>
                                                </div>
                                            </div>
                                        </div>
                                        :
                                        (
                                            eventPosts.length > 0 ?
                                                eventPosts.map((value, index) => {

                                                    return (

                                                        <div className="col" key={index}>
                                                            <>
                                                                <CardWithImage
                                                                    cardImage={value.image}
                                                                    cardTitle={value.title}
                                                                    id={value.id}
                                                                    cardTitleStyle="communityTitle"
                                                                    imageClassName="rounded-4 img-fluid community-img-height w-100"
                                                                    cardText={value.short_description}
                                                                    cardKey={index}
                                                                    carTextClassName="role-selection-description"
                                                                    cardParaTestId="professionalTestId"
                                                                    cardButtonTestId="cardButton"
                                                                    role="community"
                                                                    firstButton_Name="Register here"
                                                                    secondButton_Name="Preview"
                                                                    firstCardColor="brand-color"
                                                                    secondCardColor="outline-secondary"
                                                                    modalContent={modalApiContent}
                                                                    leftCommUrl={'https://2ndcareers.com/webinars/navigating-career-transitions-through-self-discovery/?wspage=register%27'}
                                                                    rightCommUrl={value.share_url}
                                                                    getModalData={getModalData}
                                                                    modalId={value.id}
                                                                    modalLoading={modalLoading}
                                                                />
                                                            </>


                                                            {/* scroll to top */}
                                                            <div
                                                                className="scroll-to-top-icon"
                                                                id="scroll-to-top-icon"
                                                                onClick={scrollToTop}
                                                                title="Scroll to top"
                                                                style={{ display: isVisible ? 'block' : 'none' }} // Show/hide button based on visibility state
                                                            >
                                                                <BsFillArrowUpCircleFill className='fs-1 brand-color' />
                                                            </div>

                                                        </div>
                                                    )
                                                })
                                                :
                                                <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                                                    <div className='d-flex  justify-content-center h-100'>
                                                        <img src={images.noRecordsFound} width={250} height={250} />
                                                    </div>
                                                </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* career_list */}
                    <h3 className="mb-1  ps-3 mt-5">
                        <span className="fw-semibold">Careers in Impact</span>
                    </h3>
                    {communityLoading ?
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 mt-0 mb-4">
                            {
                                communityData[0]?.careers_list && communityData[0]?.careers_list?.length > 0 ?
                                    communityData[0]?.careers_list?.map((value, index) => {
                                        return (
                                            <div className="col" key={index}>
                                                <>
                                                    <CardWithImage cardImage={value.image}
                                                        cardTitle={value.title}
                                                        id={value.id}
                                                        cardTitleStyle="communityTitle"
                                                        imageClassName="rounded-4 img-fluid community-img-height d-block mx-auto"
                                                        cardText={value.short_description}
                                                        cardKey={index}
                                                        carTextClassName="role-selection-description"
                                                        cardParaTestId="professionalTestId"
                                                        cardButtonTestId="cardButton"
                                                        role="community"
                                                        firstButton_Name="Download"
                                                        secondButton_Name="Read more"
                                                        firstCardColor="outline-secondary"
                                                        secondCardColor="brand-color"
                                                        modalContent={modalApiContent}
                                                        leftCommUrl={value.join_url}
                                                        rightCommUrl={value.share_url}
                                                        getModalData={getModalData}
                                                        modalId={value.id}
                                                        modalLoading={modalLoading}
                                                        type_of_community={value?.type_of_community}
                                                    /> 
                                                </>


                                                {/* scroll to top */}
                                                <div
                                                    className="scroll-to-top-icon"
                                                    id="scroll-to-top-icon"
                                                    onClick={scrollToTop}
                                                    title="Scroll to top"
                                                    style={{ display: isVisible ? 'block' : 'none' }} // Show/hide button based on visibility state
                                                >
                                                    <BsFillArrowUpCircleFill className='fs-1 brand-color' />
                                                </div>
                                            </div>
                                        )
                                    })

                                    :
                                    <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                                        <div className='d-flex  justify-content-center h-100'>
                                            <img src={images.noRecordsFound} width={250} height={250} />
                                        </div>
                                    </div>
                            }

                        </div>
                        :
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 mt-0 mb-4">
                            {
                                Array.from({ length: 6 }).map((v, i) => {
                                    return (
                                        <div className="col" key={i}>
                                            <div
                                                className="card border-0 p-0 rounded-3 overflow-hidden placeholder-glow"
                                                aria-hidden="true"
                                                key={i}
                                            >
                                                <div className="col-12 p-3">
                                                    <span className="placeholder col-12 py-4 rounded-top"></span>
                                                    <span className="placeholder col-12 py-4"></span>
                                                    <span className="placeholder col-12 py-4"></span>
                                                    <span className="placeholder col-12 py-4 rounded-bottom"></span>
                                                </div>
                                                <div className="card-body p-0">
                                                    <div className="p-3 py-4">
                                                        <h5 className="card-title ">
                                                            <span className="placeholder col-6 py-3 rounded-3"></span>
                                                        </h5>
                                                        <p className="card-text">
                                                            <span className="placeholder col-12 py-2 rounded "></span>
                                                            <span className="placeholder col-12 py-2 rounded"></span>
                                                            <span className="placeholder col-12 py-2 rounded"></span>
                                                            <span className="placeholder col-8 py-2 rounded"></span>
                                                        </p>
                                                    </div>
                                                    <div className="card-footer d-flex justify-content-between">
                                                        <button className="btn btn-outline-secondary placeholder col-5"></button>
                                                        <button className="btn btn-outline-secondary placeholder col-5"></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    }


                    {/* Perspectives */}
                    <h3 className="mb-1  ps-3 mt-5">
                        <span className="fw-semibold">Perspectives</span>
                    </h3>
                    {communityLoading ?
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 mt-0 mb-4">
                            {
                                communityTeam && communityTeam.length > 0 ?
                                    communityTeam.map((value, index) => {
                                        return (
                                            <div className="col" key={index}>
                                                <>

                                                    <CardWithImage cardImage={value.image}
                                                        cardTitle={value.title}
                                                        id={value.id}
                                                        cardTitleStyle="communityTitle"
                                                        imageClassName="rounded-4 img-fluid community-img-height d-block mx-auto"
                                                        cardText={value.short_description}
                                                        cardKey={index}
                                                        carTextClassName="role-selection-description"
                                                        cardParaTestId="professionalTestId"
                                                        cardButtonTestId="cardButton"
                                                        role="community"
                                                        firstButton_Name="Download"
                                                        secondButton_Name="Read more"
                                                        firstCardColor="outline-secondary"
                                                        secondCardColor="brand-color"
                                                        modalContent={modalApiContent}
                                                        leftCommUrl={value.join_url}
                                                        rightCommUrl={value.share_url}
                                                        getModalData={getModalData}
                                                        modalId={value.id}
                                                        modalLoading={modalLoading}
                                                    />



                                                </>



                                                {/* scroll to top */}
                                                <div
                                                    className="scroll-to-top-icon"
                                                    id="scroll-to-top-icon"
                                                    onClick={scrollToTop}
                                                    title="Scroll to top"
                                                    style={{ display: isVisible ? 'block' : 'none' }} // Show/hide button based on visibility state
                                                >
                                                    <BsFillArrowUpCircleFill className='fs-1 brand-color' />
                                                </div>


                                            </div>
                                        )

                                    })

                                    :
                                    <div className='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12'>
                                        <div className='d-flex  justify-content-center h-100'>
                                            <img src={images.noRecordsFound} width={250} height={250} />
                                        </div>
                                    </div>
                            }

                        </div>
                        :
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 mt-0 mb-4">
                            {
                                Array.from({ length: 6 }).map((v, i) => {
                                    return (
                                        <div className="col" key={i}>
                                            <div
                                                className="card border-0 p-0 rounded-3 overflow-hidden placeholder-glow"
                                                aria-hidden="true"
                                                key={i}
                                            >
                                                <div className="col-12 p-3">
                                                    <span className="placeholder col-12 py-4 rounded-top"></span>
                                                    <span className="placeholder col-12 py-4"></span>
                                                    <span className="placeholder col-12 py-4"></span>
                                                    <span className="placeholder col-12 py-4 rounded-bottom"></span>
                                                </div>
                                                <div className="card-body p-0">
                                                    <div className="p-3 py-4">
                                                        <h5 className="card-title ">
                                                            <span className="placeholder col-6 py-3 rounded-3"></span>
                                                        </h5>
                                                        <p className="card-text">
                                                            <span className="placeholder col-12 py-2 rounded "></span>
                                                            <span className="placeholder col-12 py-2 rounded"></span>
                                                            <span className="placeholder col-12 py-2 rounded"></span>
                                                            <span className="placeholder col-8 py-2 rounded"></span>
                                                        </p>
                                                    </div>
                                                    <div className="card-footer d-flex justify-content-between">
                                                        <button className="btn btn-outline-secondary placeholder col-5"></button>
                                                        <button className="btn btn-outline-secondary placeholder col-5"></button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })
                            }
                        </div>
                    }
                </div>
                <section className="professional-home-footer">
                    <div className="container">
                        <div className="col-12 py-3 row">
                            <div className="col-6">
                                <h6 className="mb-0">© 2024 2nd Careers. All rights reserved.</h6>
                            </div>
                            <div className="col-6">
                                <h6 className="text-end mb-0" ><span className="cursorPointer" onClick={() => window.open("https://2ndcareers.com/terms-and-conditions/", "_blank")}>Terms&nbsp;and&nbsp;conditions
                                </span> | <span className="cursorPointer" onClick={() => window.open("https://2ndcareers.com/privacy-policy/", "_blank")}>Privacy policy</span></h6>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            <Modal show={showDiscourseModal} onHide={() => setShowDiscourseModal(false)} centered>
                <Modal.Header className="border-0" closeButton />
                <Modal.Body style={{ height: '18rem', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    {
                        discourseUrl ?
                            <div className="col-6 text-center">
                                <p className="mt-2">Authenication success</p>
                                <button type="button" className="btn btn-brand-color px-3" onClick={() => window.open(discourseUrl, '_blank')}>Click here to open</button>
                            </div>
                            :
                            <div className="col-6 text-center">
                                <Spinner animation="border" role="status" />
                                <p className="mt-2">Authenicating with Discourse</p>
                            </div>
                    }

                </Modal.Body>
            </Modal>
        </>
    )
}

export default CommunityPage